import { useState } from 'react';
import { colors } from '../../colors';
import * as Styles from './tooltip.styles';

export interface TooltipProps {
  color?: 'green' | 'yellow';
  title: string;
  platforms: string[];
  subtitle: string;
  prefix: string;
  buttonText: string;
}

export function Tooltip({
  color = 'green',
  title,
  subtitle,
  prefix,
  buttonText,
  platforms,
}: TooltipProps) {
  const [isVisible, setIsVisible] = useState<boolean>(false);
  return (
    <>
      <Styles.StyledToolTip
        src="/info.svg"
        onClick={() => {
          setIsVisible(true);
        }}
      />
      <Styles.Modal
        bodyStyle={{
          backgroundColor: `${colors[color]}`,
        }}
        style={{ backgroundColor: `${colors[color]} !important` }}
        centered={true}
        visible={isVisible}
        footer={null}
        closable={false}
      >
        <Styles.Title>{title}</Styles.Title>
        <Styles.TagsContainer>
          {platforms?.length>0&& <Styles.Prefix>{prefix}</Styles.Prefix>}
          {platforms?.map((item) => (
            <Styles.Tag>{item}</Styles.Tag>
          ))}
        </Styles.TagsContainer>
        <Styles.Subtitle>{subtitle}</Styles.Subtitle>
        <Styles.CloseButton
          onClick={() => {
            setIsVisible(false);
          }}
        >
          {buttonText}
        </Styles.CloseButton>
      </Styles.Modal>
    </>
  );
}

export default Tooltip;
